import React from "react";
import { Text } from "@mbank-design/design-system/components";
import awardPng from "./img/award.png";
import "./index.scss";

const AwardBanner = (props) => {
  return (
    <div className={`award-section ${props.whitebg ? "whitebg" : ""}`}>
      <div className="award-section__container">
        <div className="award-section__typo">
          <Text as={"h2"} styledAs={"h1"}>
            mAuto nagrodzone w 14. edycji Fleet Derby 2025 w kategorii &nbsp;
            <q>
              <span className="highlighted">Usługa finansowa dla MŚP</span>
            </q>
          </Text>
          <Text as={"body"}>
            {props.text || "Nasza oferta aut nowych i poleasingowych w najmie i leasingu zyskała uznanie internautów."}
            <br />
            <br />
            Dziękujemy za zaufanie!
          </Text>
        </div>
        <div className="award-section__img">
          <img src={awardPng} alt="award" />
        </div>
      </div>
    </div>
  );
};

export default AwardBanner;
